/* Ported from ac-cat-v2 assets/pdp-gallery.js. */
/* Atlas PDP: gallery (mobile carousel + desktop dual panel), thumbs, media viewer (zoom / pan / pinch / swipe / keyboard). */
(function () {
  function init(root) {
    if (root.__pdpGallery) return;
    root.__pdpGallery = true;

    const n = parseInt(root.dataset.mediaCount, 10) || 0;
    const types = (root.dataset.mediaTypes || '').split(',');
    const car = root.querySelector('[data-car]');
    const lb = root.querySelector('[data-lb]');
    const stage = root.querySelector('[data-lb-stage]');
    const inner = root.querySelector('[data-lb-inner]');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const st = { img: parseInt(root.dataset.start, 10) || 0, z: 1, zx: 0, zy: 0, lb: false };
    let lastFocus = null;

    /* ───── media list helpers ───── */
    const isVid = () => types[st.img] === 'video';

    function playVideos() {
      root.querySelectorAll('video[data-pdp-video]').forEach((v) => {
        v.muted = true;
        v.defaultMuted = true;
        if (reduce || v.hasAttribute('data-mini') || v.closest('[data-lb]')) return;
        if (v.offsetParent === null) { v.pause(); return; }
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
      });
    }

    function render() {
      const k = st.img;
      const next = n ? (k + 1) % n : 0;
      root.querySelectorAll('[data-layer="0"]').forEach((el) => el.classList.toggle('is-on', +el.dataset.i === k));
      root.querySelectorAll('[data-layer="1"]').forEach((el) => el.classList.toggle('is-on', +el.dataset.i === next));
      root.querySelectorAll('[data-layer="lb"]').forEach((el) => el.classList.toggle('is-on', +el.dataset.i === k));
      root.querySelectorAll('[data-thumb]').forEach((el) => el.classList.toggle('is-on', +el.dataset.i === k));
      root.querySelectorAll('[data-counter]').forEach((el) => { el.textContent = (k + 1) + ' / ' + n; });
      root.querySelectorAll('[data-vidchip]').forEach((el) => { el.hidden = !isVid(); });
      if (stage) {
        stage.classList.toggle('is-video', isVid());
        // lightbox video: play the current one, pause the rest
        stage.querySelectorAll('video').forEach((v) => {
          const on = v.closest('[data-layer="lb"]') && +v.closest('[data-layer="lb"]').dataset.i === k;
          if (on && st.lb && !reduce) { v.muted = true; const p = v.play(); if (p && p.catch) p.catch(() => {}); } else v.pause();
        });
      }
      applyZoom(false);
      fitCar();
    }

    /* desktop: the square frame is sized so it ends just above the bottom of the screen on page load; the CSS needs
       to know where the gallery starts on the page (header, trust bar and spacing above it) */
    const dstage = root.querySelector('.pdp-dstage');
    const media = root.querySelector('.pdp-media');
    function measureTop() {
      /* the media column (not the sticky gallery inside it) gives where the gallery starts even after a scroll */
      if (!dstage || !media || dstage.offsetParent === null) return;
      const top = Math.round(media.getBoundingClientRect().top + window.scrollY);
      if (top > 0) root.style.setProperty('--pdp-top', top + 'px');
    }
    measureTop();
    window.addEventListener('resize', measureTop);
    window.addEventListener('load', measureTop);

    /* mobile carousel: its height follows the current slide (a vertical video slide is taller) */
    function fitCar() {
      if (!car || car.offsetParent === null) return;
      const slide = car.children[st.img];
      if (slide && slide.offsetHeight) car.style.height = slide.offsetHeight + 'px';
    }
    window.addEventListener('resize', fitCar);

    function goMedia(i, opts) {
      if (!n) return;
      const k = ((i % n) + n) % n;
      st.img = k; st.z = 1; st.zx = 0; st.zy = 0;
      render();
      if (car && !st.lb && !(opts && opts.noScroll) && car.offsetParent !== null) {
        car.scrollTo({ left: k * car.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }
      root.dispatchEvent(new CustomEvent('pdp:media', { detail: { index: k } }));
    }

    root.addEventListener('pdp:goto', (e) => goMedia(e.detail.index));
    // jump to the media featured on a variant
    root.addEventListener('pdp:variant-media', (e) => {
      const id = e.detail && e.detail.mediaId;
      if (!id) return;
      const el = root.querySelector('[data-media-id="' + id + '"]');
      if (el) goMedia(+el.dataset.i);
    });

    root.querySelectorAll('[data-thumb]').forEach((b) => b.addEventListener('click', (e) => { e.stopPropagation(); goMedia(+b.dataset.i); }));
    root.querySelectorAll('[data-prev]').forEach((b) => b.addEventListener('click', (e) => { e.stopPropagation(); goMedia(st.img - 1); }));
    root.querySelectorAll('[data-next]').forEach((b) => b.addEventListener('click', (e) => { e.stopPropagation(); goMedia(st.img + 1); }));

    if (car) {
      car.addEventListener('scroll', () => {
        if (!car.clientWidth) return;
        const i = Math.round(car.scrollLeft / car.clientWidth);
        if (i !== st.img && i >= 0 && i < n) { st.img = i; st.z = 1; st.zx = 0; st.zy = 0; render(); }
      }, { passive: true });
    }

    /* ───── lightbox open / close ───── */
    function overlay(open) {
      root.dispatchEvent(new CustomEvent('pdp:overlay', { detail: { key: 'lb', open } }));
    }
    function openLb() {
      if (!lb || !n) return;
      lastFocus = document.activeElement;
      st.lb = true; st.z = 1; st.zx = 0; st.zy = 0;
      lb.hidden = false;
      document.body.classList.add('atlas-lock');
      overlay(true);
      const t = window.Atlas && window.Atlas.isMobile && window.Atlas.isMobile();
      const hint = lb.querySelector('[data-zhint]');
      if (hint) hint.textContent = t ? hint.dataset.hintTouch : hint.dataset.hintMouse;
      render();
      const x = lb.querySelector('[data-lb-close]');
      if (x) x.focus();
    }
    function closeLb() {
      if (!st.lb) return;
      st.lb = false; st.z = 1; st.zx = 0; st.zy = 0;
      lb.hidden = true;
      document.body.classList.remove('atlas-lock');
      lb.querySelectorAll('video').forEach((v) => v.pause());
      overlay(false);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    root.querySelectorAll('[data-open-lb]').forEach((el) => {
      el.addEventListener('click', (e) => {
        if (e.target.closest('button[data-prev],button[data-next],[data-thumb]')) return;
        openLb();
      });
    });
    const closeBtn = lb && lb.querySelector('[data-lb-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeLb);

    /* ───── zoom / pan / pinch (ported from the prototype) ───── */
    const ptrs = new Map();
    let pan = null, pinch = null, sw = null;

    function zClamp(z, x, y) {
      z = Math.min(4, Math.max(1, z));
      if (!stage || z === 1) return { z, zx: 0, zy: 0 };
      const w = stage.clientWidth, h = stage.clientHeight, mx = (w * (z - 1)) / 2, my = (h * (z - 1)) / 2;
      return { z, zx: Math.max(-mx, Math.min(mx, x)), zy: Math.max(-my, Math.min(my, y)) };
    }
    function applyZoom(anim) {
      if (!inner) return;
      inner.style.transition = anim && !reduce ? 'transform .25s ease' : 'none';
      inner.style.transform = 'translate(' + st.zx + 'px,' + st.zy + 'px) scale(' + st.z + ')';
      const pct = lb && lb.querySelector('[data-zpct]');
      if (pct) pct.textContent = Math.round(st.z * 100) + '%';
      const hint = lb && lb.querySelector('[data-zhint]');
      const zoomUi = lb && lb.querySelector('[data-lb-zoom]');
      const canZoom = !isVid();
      if (hint) hint.hidden = !(canZoom && st.z === 1);
      if (zoomUi) zoomUi.hidden = !canZoom;
      if (stage) stage.classList.toggle('is-zoomed', st.z > 1);
    }
    function setZ(o, anim) { st.z = o.z; st.zx = o.zx; st.zy = o.zy; applyZoom(anim); }
    function zTo(nz, px, py, anim) {
      if (!stage) return;
      const rc = stage.getBoundingClientRect();
      const cx = (px == null ? rc.left + rc.width / 2 : px) - rc.left - rc.width / 2;
      const cy = (py == null ? rc.top + rc.height / 2 : py) - rc.top - rc.height / 2;
      const k = Math.min(4, Math.max(1, nz)) / st.z;
      setZ(zClamp(nz, cx - (cx - st.zx) * k, cy - (cy - st.zy) * k), anim !== false);
    }
    const zReset = () => { st.z = 1; st.zx = 0; st.zy = 0; applyZoom(true); };

    if (stage) {
      stage.addEventListener('wheel', (e) => {
        if (!st.lb || isVid()) return;
        e.preventDefault();
        zTo(st.z * Math.exp(-e.deltaY * 0.0025), e.clientX, e.clientY, false);
      }, { passive: false });

      stage.addEventListener('pointerdown', (e) => {
        if (e.target.closest('[data-lb-zoom],button')) return;
        if (e.pointerType === 'mouse') e.preventDefault();
        sw = (ptrs.size === 0 && st.z <= 1.01) ? { x: e.clientX, y: e.clientY, t: Date.now() } : null;
        if (isVid()) return;
        if (stage.setPointerCapture) { try { stage.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ } }
        ptrs.set(e.pointerId, { x: e.clientX, y: e.clientY });
        const pts = [...ptrs.values()];
        if (pts.length === 2) {
          pinch = { d: Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y), z: st.z, mx: (pts[0].x + pts[1].x) / 2, my: (pts[0].y + pts[1].y) / 2 };
        } else {
          pan = { x: e.clientX, y: e.clientY, zx: st.zx, zy: st.zy };
        }
      });
      stage.addEventListener('pointermove', (e) => {
        if (!ptrs.has(e.pointerId)) return;
        if (ptrs.size > 1) sw = null;
        ptrs.set(e.pointerId, { x: e.clientX, y: e.clientY });
        const pts = [...ptrs.values()];
        if (pts.length >= 2 && pinch) {
          const d = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
          zTo(pinch.z * (d / pinch.d), pinch.mx, pinch.my, false);
        } else if (pan && st.z > 1) {
          setZ(zClamp(st.z, pan.zx + e.clientX - pan.x, pan.zy + e.clientY - pan.y), false);
        }
      });
      const up = (e) => {
        const s = sw; sw = null;
        const wasZoomed = st.z > 1.01;
        ptrs.delete(e.pointerId);
        if (ptrs.size < 2) pinch = null;
        if (ptrs.size === 1) { const p = [...ptrs.values()][0]; pan = { x: p.x, y: p.y, zx: st.zx, zy: st.zy }; }
        if (!ptrs.size) pan = null;
        if (!s || wasZoomed || e.type === 'pointercancel') return;
        const dx = e.clientX - s.x, dy = e.clientY - s.y;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2 && Date.now() - s.t < 800) {
          goMedia(st.img + (dx < 0 ? 1 : -1));
        } else if (dy > 110 && Math.abs(dy) > Math.abs(dx) * 1.5) {
          closeLb();
        }
      };
      stage.addEventListener('pointerup', up);
      stage.addEventListener('pointercancel', up);
      stage.addEventListener('dblclick', (e) => {
        if (e.target.closest('[data-lb-zoom],button')) return;
        e.preventDefault();
        if (window.getSelection) window.getSelection().removeAllRanges();
        if (isVid()) return;
        if (st.z > 1) zReset(); else zTo(2.5, e.clientX, e.clientY, true);
      });
      const zin = lb.querySelector('[data-zin]'), zout = lb.querySelector('[data-zout]'), zrs = lb.querySelector('[data-zreset]');
      if (zin) zin.addEventListener('click', () => zTo(st.z * 1.5));
      if (zout) zout.addEventListener('click', () => zTo(st.z / 1.5));
      if (zrs) zrs.addEventListener('click', zReset);
    }

    /* ───── keyboard ───── */
    document.addEventListener('keydown', (e) => {
      if (!st.lb) return;
      if (e.key === 'Escape') { e.preventDefault(); closeLb(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goMedia(st.img - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); goMedia(st.img + 1); }
    });

    window.addEventListener('resize', playVideos);
    render();
    playVideos();
  }

  function boot() { document.querySelectorAll('[data-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
